import urls from "global/constants/UrlConstants";
import { getNoAuthCallParams, makeCall } from "utils/service";

export async function verifyTempPasswordOfOnboardUser(token: any) {
  try {
    const callParams = await getNoAuthCallParams("POST", token);
    const response: any = await makeCall(
      urls.VERIFY_TEMP_PASSWORD_AND_ACTIVATE,
      callParams
    );
    return response;
  } catch (error: any) {
    throw error;
  }
}
